module.exports = __webpack_public_path__ + "static/media/white_noun-540071-cc.ba6c197a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_noun-540071-cc.svg
// module id = 256
// module chunks = 0